import ContactCTA from '../components/common/ContactCTA';
import AboutPreview from '../components/home/AboutPreview';
import Hero from '../components/home/Hero';
import IndustriesPreview from '../components/home/IndustriesPreview';
import EquipmentPreview from '../components/home/EquipmentPreview';
import FAQPreview from '../components/home/FAQPreview';
import RepairProcess from '../components/home/RepairProcess';
import ServiceHighlights from '../components/home/ServiceHighlights';
import ServicesOverview from '../components/home/ServicesOverview';

function Home() {
  return (
    <>
      <Hero />
      <ServiceHighlights />
      <ServicesOverview />
      <RepairProcess />
      <AboutPreview />
      <IndustriesPreview />
      <EquipmentPreview />
      <FAQPreview />
      <ContactCTA />
    </>
  );
}

export default Home;
